import gql from "graphql-tag";

export const contentProgression = gql`
  fragment ContentProgressionFragment on Content {
    id
    ... on Folder {
      folderProgression: progression {
        allContentIds
        finishedContentIds
      }
    }
    ... on Kurssloeyfe {
      progression {
        allContentIds
        finishedContentIds
      }
    }
    ... on ExamSyllabus {
      progression {
        allContentIds
        finishedContentIds
      }
    }
  }
`;
